export default "__VITE_ASSET__oe$X79Vw__"